module.exports = __webpack_public_path__ + "img/shutterstock_5879503h.e66eef95.webp";